import { Observable } from 'rxjs'
import { BaseAction } from './base-action.model'

export abstract class BaseQuickActionProvider {
	protected constructor(readonly prefix: string) {}
	abstract search(query: string): Observable<BaseAction[]>
	abstract getPrefixHelper(): Observable<string>
}
